import { FC } from 'react'

import { useAtomValue } from 'jotai'
import { Location } from 'react-router-dom'

import { hasAnyChangesAtom } from 'Automations/automationEditor/atoms'
import { automationsPaths } from 'Automations/router'
import { Blocker } from 'common/components/Blocker'

export const UnsavedChangesBlocker: FC = () => {
  const hasAnyChanges = useAtomValue(hasAnyChangesAtom)

  return (
    <Blocker
      name="workflow editor"
      modalTitle="Leave workflow editor?"
      dirty={hasAnyChanges}
      submitting={false}
      ignoreBlock={ignoreBlock}
    />
  )
}

const NEW_EDITOR_PATH = automationsPaths.automationsEditor({
  automationId: 'new'
})
const EDITOR_PATH_PREFIX = automationsPaths.automationsEditor({
  automationId: ''
})

// Saving a new workflow redirects to the created workflow's editor URL in
// the same tick as the last-saved atoms are reset, so the blocker still
// sees the pre-save dirty state. The changes were just saved — let the
// redirect through.
const ignoreBlock = (
  nextLocation: Location,
  currentLocation?: Location
): boolean => {
  return (
    currentLocation?.pathname === NEW_EDITOR_PATH &&
    nextLocation.pathname.startsWith(EDITOR_PATH_PREFIX)
  )
}
